export default ({
  data: { blocks, order, updatedAt, warning }
}) => {
  return {
    editorBlocks: blocks,
    editorBlocksOrder: order,
    editorHeaderStatus: warning ? 'importWarning' : 'importSuccess',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDisabled: false,
    editorIsDraft: true
  };
};
